import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { applyDocumentLanguage } from "./document";
import { useLanguageStore } from "@stores/language";

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const language = useLanguageStore((s) => s.language);

    React.useEffect(() => {
        if (i18n.language !== language) void i18n.changeLanguage(language);
        applyDocumentLanguage(language);
    }, [language]);

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
